<template>
  <v-dialog v-model="opened">
    <v-card class="basic-modal" elevation="4" style="width: 560px">
      <v-card-title class="d-flex justify-space-between">
        <h5 class="heading--text d-flex align-center">
          <v-icon size="24" class="mr-4" color="red">$clock </v-icon>
          <span>{{ $t("heading.trialExpiredModal.headline") }}</span>
        </h5>
        <v-btn icon x-small @click="opened = false">
          <v-icon size="24">$close</v-icon></v-btn
        >
      </v-card-title>

      <v-card-text class="d-flex flex-column align-center">
        <TrialPlanIlustration class="mb-8" />
        <p class="p-d text--darken2 mb-0" v-html="Helper.sanitizeHtml($t('heading.trialExpiredModal.text'))"/>
      </v-card-text>

      <v-card-actions class="d-flex flex-wrap pb-0">
        <div class="w-100 pb-2">
          <v-btn
            v-if="trialUpgradeUrl"
            :href="trialUpgradeUrl"
            class="red white--text"
            large
            block
            elevation="0"
          >
            <span class="p-2 font-weight-600">{{ $t("general.upgradeNow") }}</span>
          </v-btn>
        </div>
        <div class="w-100 pb-2">
          <v-btn
            large
            block
            elevation="0"
            @click="opened = false"
            class="bg-none"
          >
            <span class="p-2 font-weight-600 text--gray-darken1"
              >{{ $t("button.cancel") }}
            </span>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
  
<script>
import TrialPlanIlustration from "../../components/illustrations/trial-plan-modal.vue";
import Helper from "../../apis/Helper";
export default {
  components: {
    TrialPlanIlustration,
  },
  data() {
    return {
      opened: false,
    };
  },
  computed: {
    Helper() {
      return Helper
    },
    trialUpgradeUrl() {
      if (!this.$store.state?.services?.data) {
        return "";
      }
      let trialService = this.$store.state?.services.getTrialService();
      if (!trialService || !trialService.plan_upgrade_link) {
        return "";
      }
      return trialService.plan_upgrade_link;
    },
  },
  methods: {
    open() {
      this.opened = true;
    },
    close() {
      this.opened = false;
    },
  },
};
</script>

<style src="./BasicModal.scss" lang="scss" scoped/>
  